<script>
  import { mdbFormInline, mdbInput } from 'mdbvue'
  export default {
    data: () => ({
      phrase: ''
    }),
    watch: {
      phrase () {
        this.$root.$emit('ReportsSearchPhrase', this.phrase)
      }
    },
    components: {
      mdbFormInline,
      mdbInput
    }
  }
</script>

<template>
  <mdb-form-inline>
    <mdb-input
      class="mr-sm-2"
      type="text"
      placeholder="Szukaj..."
      aria-label="Search"
      v-model="phrase"
    />
  </mdb-form-inline>
</template>
